<section class="users-page">
  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="users-hero">
    <div>
      <h1>Пользователи</h1>
      <span *ngIf="loading">Обновляем данные...</span>
      <span *ngIf="!loading">Общие данные профилей, роли, права доступа и блокировка пользователей.</span>
    </div>
    <button type="button" class="action-button panel-add-button" (click)="openCreateUser()" *ngIf="isAdmin">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
      <span>Добавить пользователя</span>
    </button>
  </section>

  <section class="summary-grid">
    <article class="summary-card">
      <span>Всего</span>
      <strong>{{ users.length }}</strong>
    </article>
    <article class="summary-card">
      <span>Активны</span>
      <strong>{{ activeUsersCount }}</strong>
    </article>
    <article class="summary-card">
      <span>Заблокированы</span>
      <strong>{{ blockedUsersCount }}</strong>
    </article>
    <article class="summary-card">
      <span>Администраторы</span>
      <strong>{{ adminsCount }}</strong>
    </article>
  </section>

  <section class="directory-panel">
    <div class="panel-header">
      <div>
        <h2>Команда дашборда</h2>
        <span>{{ activeUsersCount }} активны, {{ blockedUsersCount }} заблокированы</span>
      </div>
    </div>

    <div class="users-table-wrap" *ngIf="users.length > 0; else emptyUsers">
      <table class="users-table">
        <thead>
          <tr>
            <th>Пользователь</th>
            <th>Telegram ID</th>
            <th>Роль</th>
            <th>Права</th>
            <th>Статус</th>
            <th>Обновлен</th>
            <th aria-label="Действия"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users; trackBy: trackById">
            <td>
              <div class="user-cell">
                <span class="avatar">{{ getUserName(user).charAt(0) }}</span>
                <div>
                  <strong>{{ getUserName(user) }}</strong>
                  <span>{{ user.username }}</span>
                </div>
              </div>
            </td>
            <td>{{ user.telegramId || '-' }}</td>
            <td>
              <span class="role-pill">{{ getRoleLabel(user.role) }}</span>
            </td>
            <td>{{ getPermissionCount(user) }} флагов</td>
            <td>
              <span class="status-pill" [class.inactive]="!user.isActive">{{ user.isActive ? 'Активен' : 'Заблокирован' }}</span>
            </td>
            <td>{{ formatDate(user.updatedAt) }}</td>
            <td>
              <div class="row-actions">
                <button type="button" class="icon-button" title="Редактировать" (click)="openEditUser(user)">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
                </button>
                <button type="button" class="icon-button" title="Сменить пароль" (click)="openPasswordModal(user)">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                </button>
                <button type="button" class="icon-button danger" [title]="user.isActive ? 'Заблокировать' : 'Разблокировать'" (click)="toggleUserActive(user)">
                  <svg *ngIf="user.isActive" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/></svg>
                  <svg *ngIf="!user.isActive" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyUsers>
      <div class="empty-state">Пользователи пока не добавлены.</div>
    </ng-template>
  </section>

  <section class="directory-panel logs-panel">
    <div class="panel-header">
      <div>
        <h2>Журнал панели</h2>
        <span>Последние входы и действия с доступом</span>
      </div>
    </div>
    <div class="log-list" *ngIf="logs.length > 0; else emptyLogs">
      <article *ngFor="let log of logs; trackBy: trackById">
        <div>
          <strong>{{ log.username }}</strong>
          <span>{{ log.message || log.event }}</span>
        </div>
        <time>{{ formatDate(log.createdAt) }}</time>
      </article>
    </div>
    <ng-template #emptyLogs>
      <div class="empty-state">Журнал пока пуст.</div>
    </ng-template>
  </section>

  <div class="modal-backdrop" *ngIf="userModalOpen" (click)="closeUserModal()">
    <section class="user-modal" role="dialog" aria-modal="true" [attr.aria-label]="editingUser ? 'Редактирование пользователя' : 'Новый пользователь'" (click)="$event.stopPropagation()">
      <header>
        <h2>{{ editingUser ? 'Редактирование пользователя' : 'Новый пользователь' }}</h2>
        <button type="button" class="icon-button" (click)="closeUserModal()" aria-label="Закрыть">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>
      </header>

      <div class="modal-grid">
        <label>
          <span>Логин</span>
          <input type="text" [(ngModel)]="userForm.username">
        </label>
        <label>
          <span>Отображаемое имя</span>
          <input type="text" [(ngModel)]="userForm.displayName">
        </label>
        <label>
          <span>Telegram ID</span>
          <input type="text" inputmode="numeric" [(ngModel)]="userForm.telegramId" placeholder="399439578">
        </label>
        <label *ngIf="!editingUser">
          <span>Пароль</span>
          <input type="password" [(ngModel)]="userForm.password">
        </label>
        <label>
          <span>Роль</span>
          <select [(ngModel)]="userForm.role">
            <option *ngFor="let role of roles" [ngValue]="role.value">{{ role.label }} — {{ role.description }}</option>
          </select>
        </label>
      </div>

      <label class="switch-row">
        <input type="checkbox" [(ngModel)]="userForm.isActive">
        <span>{{ userForm.isActive ? 'Пользователь активен' : 'Пользователь заблокирован' }}</span>
      </label>

      <div class="permissions-grid">
        <button
          type="button"
          *ngFor="let permission of permissions"
          [class.selected]="userForm.permissions[permission.key]"
          (click)="togglePermission(permission.key)"
        >
          {{ permission.label }}
        </button>
      </div>

      <footer>
        <button type="button" class="action-button" (click)="closeUserModal()">Отмена</button>
        <button type="button" class="action-button primary" (click)="saveUser()">Сохранить</button>
      </footer>
    </section>
  </div>

  <div class="modal-backdrop" *ngIf="passwordModalOpen" (click)="closePasswordModal()">
    <section class="password-modal" role="dialog" aria-modal="true" aria-label="Смена пароля пользователя" (click)="$event.stopPropagation()">
      <header>
        <h2>Смена пароля</h2>
        <button type="button" class="icon-button" (click)="closePasswordModal()" aria-label="Закрыть">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>
      </header>
      <p>{{ passwordUser ? getUserName(passwordUser) : '' }}</p>
      <label>
        <span>Новый пароль</span>
        <input type="password" [(ngModel)]="passwordValue">
      </label>
      <footer>
        <button type="button" class="action-button" (click)="closePasswordModal()">Отмена</button>
        <button type="button" class="action-button primary" (click)="saveUserPassword()">Обновить</button>
      </footer>
    </section>
  </div>
</section>
